var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mb-4" },
    [
      _c(
        "b-col",
        {
          staticClass: "d-flex flex-row align-items-center",
          attrs: { cols: "10", lg: "6" },
        },
        [
          _c(
            "a",
            {
              staticClass: "pt-2 mr-3",
              attrs: { href: "#/automation/drip-campaigns" },
            },
            [
              _c("span", [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("arrow_back"),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "mb-0" }, [
            _vm._v("\n      " + _vm._s(_vm.name) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center ml-4" },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v(" " + _vm._s(_vm.$t("drip-campaigns.createdBy")) + ": "),
              ]),
              _vm._v(" "),
              _c(
                "profile-avatar",
                _vm._b(
                  {
                    staticClass: "client-avatar mr-2 d-none d-sm-inline-flex",
                    staticStyle: { width: "1.4rem", height: "1.4rem" },
                  },
                  "profile-avatar",
                  _vm.createdBy,
                  false
                )
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("fullName")(_vm.createdBy)) +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "d-flex flex-row justify-content-end align-items-center",
          attrs: { cols: "2", lg: "6" },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-row header-buttons" },
            [
              _c("button-bar", {
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row justify-content-end align-items-center",
                          },
                          [
                            _c(
                              "plan-tooltip",
                              {
                                attrs: {
                                  page: _vm.currentPagePlan,
                                  disabled: !_vm.disabledSwitch,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pretty p-switch p-fill d-flex align-items-center justify-content-center mt-1 mr-3",
                                    class: { disabled: _vm.disabledSwitch },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isActivated,
                                          expression: "isActivated",
                                        },
                                      ],
                                      key: "is-activated-" + _vm.isActivated,
                                      attrs: {
                                        id: "active-drip-campaign",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.isActivated)
                                          ? _vm._i(_vm.isActivated, null) > -1
                                          : _vm.isActivated,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.isActivated,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isActivated = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isActivated = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isActivated = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "active-drip-campaign",
                                          hidden: "",
                                        },
                                      },
                                      [_vm._v("Active")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "state" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "mb-0 ml-1",
                                          style: { marginTop: "1px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("global.words.active")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "simple-button",
                              {
                                attrs: {
                                  id: "drip-campaign-edit-button",
                                  type: "primary",
                                  "class-name": "btn-sm",
                                  disabled: !_vm.isValid,
                                  loading: _vm.loadingSaving,
                                },
                                on: { click: _vm.handleSaveChanges },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("global.actions.saveChanges")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "m-2",
                                attrs: {
                                  id: "dropdown-dropleft",
                                  text: _vm.$t("global.words.actions"),
                                  variant: "white",
                                  "menu-class": "overflow-visible",
                                },
                              },
                              [
                                _c(
                                  "b-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.left",
                                        value: {
                                          title: _vm.$t(
                                            "drip-campaigns.messages.disabledTooltipText"
                                          ),
                                          disabled: !_vm.isActivated,
                                        },
                                        expression:
                                          "{\n                  title: $t('drip-campaigns.messages.disabledTooltipText'),\n                  disabled: !isActivated\n                }",
                                        modifiers: { left: true },
                                      },
                                    ],
                                    on: { click: _vm.handleShowDeleteModal },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          disabled: _vm.isActivated,
                                          "text-danger": true,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "drip-campaigns.actions.deleteDripCampaign"
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { on: { click: _vm.handleExportStatistics } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("global.actions.downloadAsCSV")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  { on: { click: _vm.showClientsModal } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "drip-campaigns.actions.clientsWithin"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "button-content",
                    fn: function () {
                      return [
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-sm btn-white dropdown-toggle clickable",
                          },
                          [_vm._v(_vm._s(_vm.$t("global.words.actions")))]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "dropdown-content",
                    fn: function () {
                      return [
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.left",
                                value: {
                                  title: _vm.$t(
                                    "drip-campaigns.messages.disabledTooltipText"
                                  ),
                                  disabled: !_vm.isActivated,
                                },
                                expression:
                                  "{\n              title: $t('drip-campaigns.messages.disabledTooltipText'),\n              disabled: !isActivated\n            }",
                                modifiers: { left: true },
                              },
                            ],
                            on: { click: _vm.handleShowDeleteModal },
                          },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  disabled: _vm.isActivated,
                                  "text-danger": true,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "drip-campaigns.actions.deleteDripCampaign"
                                      )
                                    )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          { on: { click: _vm.handleExportStatistics } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("global.actions.downloadAs", {
                                    item: "CSV",
                                  })
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          { on: { click: _vm.showClientsModal } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("drip-campaigns.actions.clientsWithin")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function () {
                                return (_vm.isActivated = !_vm.isActivated)
                              },
                            },
                          },
                          [
                            _c(
                              "plan-tooltip",
                              { attrs: { page: "drip-campaigns" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.isActivated
                                        ? _vm.$t("global.words.active")
                                        : _vm.$t("global.words.inactive")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-dropdown-divider"),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: { disabled: !_vm.isValid },
                            on: { click: _vm.handleSaveChanges },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.actions.saveChanges")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("drip-campaign-clients-modal", {
            ref: "clientsModal",
            attrs: { "campaign-id": _vm.campaignId },
          }),
          _vm._v(" "),
          _c("drip-campaign-delete-modal", {
            ref: "deleteModal",
            attrs: { "campaign-id": _vm.campaignId },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }